<template>
  <div id="apoio">
    <!-- <div class="telefone">Suporte: (11) 5643-5408</div> -->
    <div class="comunicado">
      <h2>Comunicado</h2>
      <p class="text">
        Após 40 anos de parceria com o Sistema Anglo de Ensino, a Pisco
        Sistemas informa que a parceria institucional com a SomoS Educação
        foi encerrada e que não há mais vínculo contratual entre as
        empresas.
      </p>
      <p class="text">
        Em respeito à longa história construída em conjunto e,
        principalmente, às escolas conveniadas que utilizaram nossas
        soluções durante todos esses anos, manteremos temporariamente
        disponível o download do Leitor SiaaE.
      </p>
      <p class="text">
        Essa medida tem como objetivo permitir que cada instituição realize,
        de forma gradual e organizada, a adaptação de seus processos durante
        este período de transição.
      </p>
      <p class="text">
        Agradecemos a confiança depositada em nosso trabalho ao longo dessas
        quatro décadas e reafirmamos nosso compromisso com a qualidade, a
        seriedade e o respeito que sempre nortearam nossa atuação.
      </p>
      <p class="assinatura">
        <strong>Pisco Sistemas</strong><br />
        Há 40 anos desenvolvendo soluções para a avaliação educacional.
      </p>
    </div>

    <div class="wrapper">
      <!-- ############################################### -->
      <!-- ### MENU MOBILE : VISÍVEL EM TELAS PEQUENAS ### -->
      <!-- ############################################### -->
      <div id="menu-mobile">
        <!-- <div @click="showDownloadModal('cadastro')" class="button-body">
          <div class="icon">
            <img src="@/assets/icon_exe_cadastro.png" alt="" />
          </div>
          <div class="label">Cadastro</div>
        </div>

        <div @click="showDownloadModal('coordenador')" class="button-body">
          <div class="icon">
            <img src="@/assets/icon_exe_coord.png" alt="" />
          </div>
          <div class="label">Coordenador</div>
        </div> -->

        <div @click="$emit('show-download-modal', 'leitora')" class="button-body">
          <div class="icon">
            <img src="@/assets/icon_exe_leitora.png" alt="" />
          </div>
          <div class="label">Leitora SiaaE</div>
        </div>
      </div>

      <!-- ##################################################### -->
      <!-- ### MENU WIDE : VISÍVEL EM TELAS MÉDIAS E GRANDES ### -->
      <!-- ##################################################### -->
      <div id="menu-wide">
        <!-- <div class="icon-body" @click="showDownloadModal('cadastro')">
          <div class="icon">
            <img src="@/assets/icon_exe_cadastro.png" alt="" />
          </div>
          <div class="label">Cadastro</div>
        </div>

        <div class="icon-body" @click="showDownloadModal('coordenador')">
          <div class="icon">
            <img src="@/assets/icon_exe_coord.png" alt="" />
          </div>
          <div class="label">Coordenador</div>
        </div> -->

        <div class="icon-body" @click="$emit('show-download-modal', 'leitora')">
          <div class="icon">
            <img src="@/assets/icon_exe_leitora.png" alt="" />
          </div>
          <div class="label">Leitora SiaaE</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Apoio",
};
</script>

<style lang="scss" scoped>
#apoio {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  align-content: stretch;
  justify-content: center;
  flex: 1 1 auto;
  background-color: white;

  .telefone {
    display: block;
    width: 100%;
    flex: 0 0 auto;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    padding: 8px;
    box-sizing: border-box;
    background-color: #1f4a99;
    color: white;
  }

  .comunicado {
    display: block;
    flex: 0 0 auto;
    width: 100%;
    max-width: 640px;
    box-sizing: border-box;
    margin: 24px auto 0;
    padding: 16px 20px;
    background-color: #eef2f7;
    border-top: 4px solid #1f4a99;
    border-radius: 6px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.1);

    h2 {
      display: block;
      margin: 0 0 8px;
      color: #1f4a99;
      font-size: 20px;
      font-weight: 700;
    }

    p {
      display: block;
      margin: 0 0 10px;
      font-size: 14px;
      line-height: 21px;
      font-weight: 400;
      color: #333;
    }

    .assinatura {
      margin: 4px 0 0;
      padding-top: 10px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  .wrapper {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    align-content: stretch;
    justify-content: center;
    flex: 1 1 auto;
  }

  #menu-mobile {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 32px;

    .button-body {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      align-content: center;
      justify-content: flex-start;
      flex: 0 0 auto;
      text-decoration: none;
      border: none;
      outline: none;
      text-decoration: none;
      border-radius: 6px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      cursor: pointer;
      background-color: #607594;
      height: 72px;
      margin: 16px 0px;
      width: 100%;
      color: white;
      font-size: 18px;
      font-weight: 500;
      transition: all 0.2s ease-in-out;

      &:hover {
        background-color: #4d5f7a;
      }

      .icon {
        display: block;
        flex: 0 0 auto;
        width: 54px;
        height: 54px;
        margin: 0px 16px;
        border-radius: 6px;
        overflow: hidden;

        img {
          width: 54px;
          height: 54px;
        }
      }
    }
  }

  #menu-wide {
    display: none;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
    flex: 0 0 auto;
    width: 100%;
    max-width: 920px;

    .icon-body {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      align-content: center;
      justify-content: center;
      flex: 0 0 auto;
      text-decoration: none;
      border: none;
      outline: none;
      text-decoration: none;
      cursor: pointer;

      .icon {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        align-content: center;
        justify-content: center;
        width: 200px;
        height: 200px;
        border-radius: 20px;
        transition: all 0.2s ease-in-out;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        background-color: #fff;
        margin: 5px;
        box-sizing: border-box;
        overflow: hidden;

        img {
          display: block;
          width: 100%;
          transition: inherit;
        }
      }

      .label {
        display: block;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        margin-top: 16px;
        color: #2c2c2c;
        transition: color 0.2s ease-in-out;
      }

      &:hover {
        .icon {
          box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3),
            0 15px 12px rgba(0, 0, 0, 0.22);
          width: 210px;
          height: 210px;
          margin: 0px;
        }

        .label {
          color: #607594;
        }
      }
    }
  }
}

@media only screen and (min-width: 670px) {
  #apoio {
    #menu-mobile {
      display: none;
    }

    #menu-wide {
      display: flex;
    }
  }
}

@media only screen and (min-width: 380px) {
  #apoio {
    #menu-mobile {
      .button-body {
        font-size: 26px;
      }
    }
  }
}
</style>
